import { useQuery } from '@tanstack/react-query';

import {
  getPolicyPackagesForParty,
  type GetPolicyPackagesForPartyResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export default function usePolicyPackages(
  partyId: string,
  filter?: {
    activeOnly?: boolean;
  },
  options?: QueryOptions<GetPolicyPackagesForPartyResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.policyPackages.list(partyId, filter),
    queryFn: async () => {
      const result = await getPolicyPackagesForParty(
        { path: { party_id: partyId } },
        wgApi,
      );

      if (filter?.activeOnly) {
        return result.items.filter((p) =>
          p.insurance_policies.some((policy) => policy.status === 'ACTIVE'),
        );
      }

      return result.items;
    },
    ...options,
  });
}
